'use client';

import { c as _c } from "react/compiler-runtime";
import { Suspense } from 'react';
import Error from '@/components/Error';
import ErrorBoundary from '@/components/ErrorBoundary';
import { QuickLinks } from '@/components/QuickLinks';
import SubmitButton from '@/components/SubmitButton';
import { flushRedisAction } from '@/operations/flushRedisAction';
function FlushRedisCache() {
  const $ = _c(1);
  if (process.env.NEXT_PUBLIC_REVISION !== "dev" || process.env.NEXT_PUBLIC_DEPLOY_ENVIRONMENT === "test") {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <QuickLinks id="flush-redis-cache"><ErrorBoundary errorComponent={Error}><Suspense fallback={null}><form action={flushRedisAction}><input type="hidden" name="revision" value={process.env.NEXT_PUBLIC_REVISION} /><SubmitButton>Flush Redis Cache</SubmitButton></form></Suspense></ErrorBoundary></QuickLinks>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export default FlushRedisCache;